import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, UntypedFormControl, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { interval, Observable, of, Subject, timer } from 'rxjs';
import { catchError, finalize, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { DocumentLanguage, Template, ValidateUrlRequest } from 'src/app/_shared/models/article';
import { BrandVoice, GetBrandVoiceListRequest, GetBrandVoiceListResponse, GetTargetAudienceListRequest, GetTargetAudienceListResponse, TargetAudience, BrandVoiceThingJson } from 'src/app/_shared/models/article';
import { ContentStudioTrackingService } from 'src/app/_shared/services/tracking/contentstudio-tracking.service';
import { MwcModalRef, MwcModalService } from 'mwc/modal';
import { MwcUploadChangeParam, MwcUploadFile } from 'mwc/upload';
import { MwcNotificationModule, MwcNotificationService } from 'mwc/notification';
import { AnalyzeUrlsRequest, AnalyzeUrlsResponse, ContentInstructionDocument, KeywordDocumentUploadData, UploadInstDocsRequest } from 'src/app/_shared/models/campaigns';
import { StorageHelper } from 'src/app/_utilities/storage-helper';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { Router } from '@angular/router';
import { WebpageTemplateService } from 'src/app/services/webpageTemplate/webpageTemplate.service';
import { ArticleService } from '../../../../../services/article/article.service';
import { GenerateCampaignArticlesForCustomTemplateRequest, GenerateCampaignArticlesRequest, PageConfiguration, WebpageKeywordTemplateMappingRequest, WebpageKeywordTemplateMappingResponse } from 'src/app/_shared/models/GenerateCampaignArticlesRequest';
import { GenerationInProgressHelperService } from 'src/app/_shared/services/helper/generation-in-progress-popup/generation-in-progress-popup-helper.service';
import { CampaignData } from 'src/app/campaigns/view-campaigns/view-campaigns.component';
import { ArticleStoreService } from 'src/app/services/article/article-store.service';
import { topicIdea } from 'src/app/_shared/models/topic';
import { ArticleHelperService } from 'src/app/_shared/services/helper/article/article-helper.service';
import { ErrorModalOrigins } from 'src/app/_shared/consts/article-constants';
import { WebpageTemplateRequest } from 'src/app/_shared/models/webpage-template.model';

export interface TemplateSection {
  id: string;
  sectionTitle: string;
  wordCount: number;
  contentPrompt: string;
  sortOrder:number;
}
export interface CustomTemplate {
  id: string;
  name: string;
  sections: TemplateSection[];
  isSelected?: boolean;
}
@Component({
  selector: 'app-custom-template-workflow-tabset',
  templateUrl: './custom-template-workflow-tabset.component.html',
  styleUrls: ['./custom-template-workflow-tabset.component.scss']
})
export class CustomTemplateWorkflowTabsetComponent implements OnInit {
  @Input() template: Template;

  workflowForm: FormGroup;
  selectedIndex = 0;
  isAnalyzing = false;
  isUploadAnalyzing = false;
  isLoading = false;
  isParentUrlVisible = true;
  isIndividualUrlVisible = false;
  showContentInstructions = false;
  webpageKeywordMap:{ [key: string]: string[] };
  /*== hiding to maintain only global and common  seo check list and new list was updated in generation-in-progress-popup-helper service==*/
  /* seoAnalysisList: { title: string; desc?: string }[] = [
    { 'title': 'Focus on Quality Content', 'desc': 'Ensure your content is informative, engaging, and valuable to your audience' },
    { 'title': 'Optimize for Keywords', 'desc': 'Research and use relevant keywords naturally in your content to improve visibility' },
    { 'title': 'Use Descriptive URLs', 'desc': 'Make URLs descriptive, short, and keyword-rich to enhance understanding and SEO' },
    { 'title': 'Optimize Title Tags', 'desc': 'Include target keywords in title tags while making them compelling to click' },
    { 'title': 'Craft Compelling Meta Descriptions', 'desc': 'Write unique and enticing meta descriptions for each page to improve click-through rates.' },
    { 'title': 'Utilize Header Tags', 'desc': 'Structure your content with H1, H2, and H3 tags to improve readability and SEO.' },
    { 'title': 'Optimize Images', 'desc': 'Use descriptive filenames and alt text for images to improve accessibility and relevance.' },
    { 'title': 'Improve Site Speed', 'desc': 'Ensure your website loads quickly on all devices to reduce bounce rates and enhance user experience.' },
    { 'title': 'Mobile-Friendly Design', 'desc': 'Optimize your website for mobile users to cater to the increasing mobile traffic.' },
    { 'title': 'Secure Your Site with HTTPS', 'desc': 'Implement HTTPS to secure your site and boost its ranking signal.' },
    { 'title': 'Create Quality Backlinks', 'desc': 'Gain backlinks from reputable sites to enhance your site’s credibility and search ranking.' },
    { 'title': 'Use Social Media to Boost Visibility', 'desc': 'Share your content on social media platforms to increase traffic and engagement.' },
    { 'title': 'Implement Local SEO Practices', 'desc': 'Optimize your site for local search terms and listings to attract local customers.' },
    { 'title': 'Monitor Your Sites Performance', 'desc': 'Use tools like Google Analytics and Search Console to track traffic, performance, and issues.' },
    { 'title': 'Update Content Regularly', 'desc': 'Keep your site fresh with regular updates and new content to engage visitors and search engines.' },
    { 'title': 'Optimize for Voice Search', 'desc': 'Include conversational keywords and FAQs to capture voice search queries.' },
    { 'title': 'Use Internal Linking Wisely', 'desc': 'Create internal links to guide visitors to relevant content, improving site navigation and SEO.' },
    { 'title': 'Avoid Duplicate Content', 'desc': 'Ensure your content is unique across your site to avoid penalties from search engines.' },
    { 'title': 'Leverage Schema Markup', 'desc': 'Implement structured data to help search engines understand and display your content more prominently.' },
    { 'title': 'Stay Updated with SEO Practices', 'desc': 'SEO is ever-evolving; stay informed about the latest trends and algorithm updates to keep your site competitive.' }
  ]; */
  // Keywords management

  allKeywords: string[] = [];
  selectedKeywords: string[] = [];
  maxKeywordsAllowed = 100000000;
  keywordInputVisible = false;
  selectedKeywordInputValue = '';
  isKeywordTagsVisible:boolean = true;
  isKeywordUploadVisible:boolean = false;

  indeterminate = false;
  checked = false;

  // Dummy data for pages with assigned keywords
  pages = [];
  templates: CustomTemplate[] = [];  
  campaignName:string = '';
  activePageIndex: number | null = null;

  @ViewChild('inputElement', { static: false }) inputElement?: ElementRef;

  // Tab structure with disable state
  tabs = [
    { index: 0, name: 'Analyze Website', disable: false, iconName: 'file-search-03', completed: false, visible: true },
    { index: 1, name: 'Add Keywords', disable: true, iconName: 'key-02', completed: false, visible: true },
    { index: 2, name: 'Webpages', disable: true, iconName: 'browser', visible: true },
    { index: 3, name: 'Upload Docs', disable: true, iconName: 'upload-01', selected: false, visible: true },
    { index: 4, name: 'Brand Voice', disable: true, iconName: 'clipboard-report', selected: false, visible: true },
    { index: 5, name: 'Target Audience', disable: true, iconName: 'users-03', selected: false, visible: true },
    { index: 6, name: 'Language', disable: true, iconName: 'translate-02', selected: false, visible: true },
  ];
  
  _storageHelper: StorageHelper;
  private destroy$ = new Subject<void>();
  profileId: number;
  campaignId: string;
  brandId: string = null;
  timeout = null;
  // Brand Voice properties
  isNoCreateBrandVoice: boolean = true;
  brandVoiceList = [];
  filteredBrandVoiceList = [];
  selectedBrandVoice: string;
  @ViewChild('contentTextarea') contentTextarea!: ElementRef<HTMLTextAreaElement>;
  brandVoiceDetails: { label: string, value: string, tone: string, createdOn: string, createdBy: string, brandVoiceDocument: string, details: BrandVoiceThingJson };
  isExpanded = false;
  isDefaultBVAvailable: boolean = false;
  defaultBVId: number = 0;
  isShowDetailsBV: boolean = false;
  FoundSerchBV: boolean = true;
  searchTxt: string = '';
  bvSearchField: FormControl = new FormControl();

  // Target Audience properties
  tvSearchField: FormControl = new FormControl();
  isShowDetailsTA = false;
  FoundSearchTA = true;
  isNoTargetAudience: boolean = true;
  selectedTargetAudience: string;
  targetAudienceList = [];
  filteredTargetAudienceList = [];
  targetAudienceDetails: TargetAudience;
  isDefaultTAAvailable: boolean = false;
  defaultTAId: number = 0;

  //Language properties
  selectedValueLanguage =  "US";


  //
  keywordAnalysisinProgress:boolean = false;
  editingPagenId: string | null = null;
  originalPageName:string = '';
  isAddingNewSection:boolean = false;
  newSection: any = {
    id: '',
    title: '',
    url: '',
    keywords: [],
    template: '',
    disabled: false
  };

  provinceData = [
    //{ id: 30, label: "Arabic", languageCode: "ar", value: "SA" } Saudi Arabia
    { id: 12, label: "English", languageCode: "en", value: "US" }, // United States
    { id: 199, label: "English(UK)", languageCode: "gb", value: "GB" }, // English(UK)
    { id: 16, label: "French", languageCode: "fr", value: "FR" }, // France
    { id: 15, label: "German", languageCode: "de", value: "DE" }, // Germany
    { id: 11, label: "Hindi", languageCode: "hi", value: "IN" }, // India
    { id: 86, label: "Indonesian", languageCode: "id", value: "ID" }, // Indonesia
    { id: 29, label: "Japanese", languageCode: "ja", value: "JP" }, // Japan
    { id: 18, label: "Korean", languageCode: "ko", value: "KR" }, // South Korea
    { id: 190, label: "Mandarin", languageCode: "zh-CN", value: "CN" }, // China
    { id: 9, label: "Portuguese", languageCode: "pt", value: "PT" }, // Portugal
    //{ id: 26, label: "Portuguese (Mexico)", languageCode: "pt-mx", value: "PT" }, // Brazil
    { id: 8, label: "Russian", languageCode: "ru", value: "RU" }, // Russia
    { id: 17, label: "Spanish", languageCode: "es", value: "ES" }, // Spain
    { id: 32, label: "Spanish (Mexico)", languageCode: "es-mx", value: "MX" }, // Mexico
    { id: 31, label: "Swahili", languageCode: "sw", value: "KE" }, // Kenya
    { id: 170, label: "Turkish", languageCode: "tr", value: "TR" }, // Turkey
    { id: 25, label: "Vietnamese", languageCode: "vi", value: "VN" }, // Vietnam
    //{ id: 63, label: "Chinese", languageCode: "zh", value: "CN" } //Chinese
  ];

  documentDetails: ContentInstructionDocument[] = [];
  waitingScreenforAnalysis = false;
  isGoToCampaignsEnabled = false;
  highlights: { [key: string]: string[] } = {};
  keywordDocumentData: KeywordDocumentUploadData | null = null;
  keywordDocumentFile: File | null = null;


  newTagText: string = '';
  showTagInput:boolean = false;
  isDuplicateKeyword: boolean = false;
  constructor(
    private fb: FormBuilder,
    private tracking: ContentStudioTrackingService,
    private modalRef: MwcModalRef,
    private notification: MwcNotificationService,
    public cdRef: ChangeDetectorRef,
    private campaignService: CampaignService,
    private router: Router,
    private modalService: MwcModalService,
    private webpageTemplateService: WebpageTemplateService,
    private articleService: ArticleService,
    private generationInProgressHelperService: GenerationInProgressHelperService,
    private articleStoreService: ArticleStoreService,
    private articleHelperService: ArticleHelperService
  ) {
    this._storageHelper = new StorageHelper();
    this.workflowForm = this.fb.group({
      websiteUrl: ['', [Validators.required, Validators.pattern('https?://.+')]],
      individualUrls: [''],
      selectedTemplate: [''],
      brandPersonality: [''],
      brandTone: [''],
      contentFormat: [''],
      targetAudience: [''],
      metaTitle: [''],
      metaDescription: ['']
    });
  }
  keywordListFromAddKeywordTab:string[] = [];
  /* Brand Modal */
  brandSelection:any[] = [];
  brandSelectedValue:string = '';
  isAddBrandModalVisible: boolean = false;
  newBrandName:string = '';
  errorMessage: string;

  ngOnInit(): void {
    // Initialize any data or settings here
    this.initForm();
    this.fetchProfileBrands();
    this.fetchBrandVoices();
    this.fetchTargetAudiences();
    // Initialize language dropdown with default value
    this.selectedValueLanguage = 'US';
    this.languageChanged(this.selectedValueLanguage);

    const mwcData = this.modalRef.getConfig().mwcData || {};
    if (mwcData.isIndividualUrls != null) {
      this.isIndividualUrlVisible = mwcData.isIndividualUrls;
      this.isParentUrlVisible = !mwcData.isIndividualUrls;
    }
    if (mwcData.urls != null && Array.isArray(mwcData.urls) && mwcData.urls.length > 0) {
      if (mwcData.isIndividualUrls) {
        this.workflowForm.get('individualUrls')?.setValue(mwcData.urls.join('\n'));
        this.isIndividualUrlVisible = true;
        this.isParentUrlVisible = false;
      } else {
        this.workflowForm.get('websiteUrl')?.setValue(mwcData.urls[0]);
        this.isIndividualUrlVisible = false;
        this.isParentUrlVisible = true;
      }
    }
    if (mwcData.keywords != null && Array.isArray(mwcData.keywords) && mwcData.keywords.length > 0) {
      this.keywordListFromAddKeywordTab = [...mwcData.keywords];
      this.selectedKeywords = [...mwcData.keywords];
      this.workflowForm.get('keywords')?.setValue(mwcData.keywords.join(', '));
      this.listOfOption = Array.from(new Set([...this.listOfOption, ...mwcData.keywords.map(k => ({ label: k, value: k }))]));
    }
    if (mwcData.selectedTabIndex != null && !isNaN(mwcData.selectedTabIndex)) {
      this.tabs.forEach((tab, index) => {
        // Only the first two tabs (index 0 and 1) should be disabled as needed
        // All other tabs should have disable set to false
        if (index > 1) {
          tab.disable = false;
        }
        else{
          tab.disable = true;
        }
      });
      this.selectedIndex = mwcData.selectedTabIndex;
    }
    if(mwcData.templates != null && Array.isArray(mwcData.templates) && mwcData.templates.length > 0){
      this.templates = mwcData.templates.map((t, index) => ({
              id: t._id,
              name: t.name,
              sections: t.sections?.map(s => ({
                id: s.id ?? '',
                sectionTitle: s.title,
                wordCount: s.wordCount,
                contentPrompt: s.contentPrompt,
                sortOrder: s.sortOrder
              })) || [],
              isSelected: index === 0
            }));
      this.templateOptions = this.templates.map(t => ({
            label: t.name,   
            value: t.id   
          }));      
    }
    if(mwcData.webpageConfigurationAndDocumentDetails != null){
      const detailsArray = mwcData.webpageConfigurationAndDocumentDetails.map(detail => ({
        ...detail,
        pages: detail.pages.filter(page =>page.httpStatusCode === 200)
      }));
      const details = detailsArray[0];
      this.pages = details.pages.map((page, index) => ({
        id: index + 1,
        title: page.title,
        url: page.pageUrl,
        keywords: (page.keywords || []).filter(k => this.selectedKeywords.includes(k)),
        template: page.templateId,
        disabled: false
      }));
      this.profileId = details.profileId;
      this.campaignId = details.campaignId;
      this.brandId = details.brandId;
      this.onAllChecked(true);
    }
    if(mwcData.campaignName){
      this.campaignName = mwcData.campaignName;
    }
    // Initialize brand voice and target audience search fields
    //this.bvSearchField.valueChanges.pipe(
    //  takeUntil(this.destroy$)
    //).subscribe(val => {
    //  this.triggerSearchBV(val);
    //});

    // Initialize Target Audience search field
    //this.tvSearchField.valueChanges.pipe(
    //  takeUntil(this.destroy$)
    //).subscribe(val => {
    //  this.triggerSearchTA(val);
    //});
    
    // Ensure no brand voice or target audience is selected by default
    this.filteredBrandVoiceList.forEach(bv => {
      bv.isSelectedBV = false;
    });
    this.filteredTargetAudienceList.forEach(ta => {
      ta.isSelectedTA = false;
    });

    // Track page view
    // this.tracking.trackEvent(
    //   'pageview', `Custom Template Workflow - ${this.template?.title || 'Unknown'}`
    // );
    //this.getTemplates();
    //const control = this.workflowForm.get('websiteUrl');
    //control?.updateValueAndValidity();
  }
   getTemplates(){
    var req:WebpageTemplateRequest = {
      profileId: this._storageHelper.user.pId,
      brandId: this.brandSelectedValue ?? null
    }
    this.webpageTemplateService.getTemplates(req).subscribe({
      next: (res) => {
        if (res.success && res.templates) {
          this.templates = res.templates.map((t, index) => ({
            id: t._id,
            name: t.name,
            sections: t.sections?.map(s => ({
              id: s.id ?? '',
              sectionTitle: s.title,
              wordCount: s.wordCount,
              contentPrompt: s.contentPrompt,
              sortOrder: s.sortOrder
            })) || [],
            isSelected: index === 0
          }));
          this.templateOptions = res.templates.map(t => ({
            label: t.name,   
            value: t._id   
          }));
        } else {
          this.templateOptions = [];
          this.templates = [];
        }
      },
      error: () => {
        this.templateOptions = [];
        this.templates = [];
      }
    });
  }

  fetchProfileBrands(){
    this.webpageTemplateService.GetProfileBrands({ profileId: this._storageHelper.user.pId })
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (brandRes) => {
          this.brandSelection = brandRes.brands?.filter(b => b.hasTemplates).map(b => ({
            label: b.name,
            value: b.id
          })) || [];
          //this.brandSelectedValue = brandRes.brands?.find(b => b.isDefault)?.id || '';
          this.cdRef.detectChanges();
        },
        error: () => {
          this.brandSelection = [];
        }
      });
  }

  private initForm(): void {
    this.workflowForm = this.fb.group({
      websiteUrl: new UntypedFormControl(
        '',
        {
          validators: [
            this.urlValidator,
            this.emptyUrlValidator.bind(this),
            this.urlLengthValidator,
            this.nonHtmlResourceValidator.bind(this)
          ],
          asyncValidators: [this.urlAccessibilityValidator.bind(this)],
          updateOn: 'change'
        }
      ),
      keywords: [''],
      pageTitle: [this.template?.titleText || ''],
      pageDescription: [''],
      brandVoice: this.selectedBrandVoice,
      brandVoiceDocument: "",
      brandVoiceDetails: null,
      brandVoiceId: 0,
      targetAudience: this.selectedTargetAudience,
      targetAudienceId: 0,
      targetAudienceDetails: null,
      language: ['English (US)'],
      individualUrls: new UntypedFormControl('',[this.multiUrlValidator.bind(this)]),
    });
  }
  // Tab Management
  tabsSetSelectChange(index: number): void {
    if (!this.tabs[index].disable) {
      this.selectedIndex = index;
    }
  }

  tabSelectChange(event: any): void {
    const [type, tab] = event;
    
    // Find the index of the tab in the tabs array
    const index = this.tabs.filter(s => s.visible).findIndex(t => t.name === tab.name);
    this.selectedIndex = index;
   /*  
    // Special case for Content Instructions tab
    if (tab.name === this.contentInstructionsTab.name) {
      this.selectedIndex = 6; // Specific index for Content Instructions
    } else if (index !== -1 && !this.tabs[index].disable) {
      this.selectedIndex = index;
    } */
  }
  
  nonHtmlResourceValidator(control: AbstractControl): ValidationErrors | null {
    const val = (control.value || '').trim();
    if (!val) return null; // empty handled elsewhere
    return this.isNonHtmlResource(val) ? { nonHtmlResource: true } : null;
  }

  isNonHtmlResource(rawUrl: string): boolean {
    try {
      const normalized = /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`;
      const u = new URL(normalized);
      const path = (u.pathname || '').toLowerCase();

      // Block common non-HTML resources: PDFs, images, archives
      const disallowedExt = /\.(pdf|png|jpe?g|gif|bmp|webp|svg|ico|tiff?|zip|rar|7z|tar|gz|tgz|bz2)$/i;
      return disallowedExt.test(path);
    } catch {
      // If it's not a valid URL, let the invalidUrl validator handle it
      return false;
    }
  }

  urlLengthValidator(control: AbstractControl): ValidationErrors | null {
      const val = (control.value || '').trim();
      if (!val) return null; // empty handled by emptyUrlValidator
      return val.length > 2048 ? { urlTooLong: true } : null;
  }

  urlToCrawl:string='';
  urlAccessibilityValidator(control: AbstractControl): Observable<ValidationErrors | null> {
    if (control.invalid) {
      return of(null);
    }
    const value = (control.value || '').trim();
    if (!value) {
      return of(null);
    }
    return timer(1000).pipe( 
      switchMap(() => {
        const req = new ValidateUrlRequest();
        req.urls = [value];
        return this.articleService.ValidateUrl(req).pipe(
          map(res => {
            const validation = res?.urlValidations?.[0];
            if (!validation) {
              return { genericError: true };
            }
            this.urlToCrawl = validation.responseUrl;
            const status = validation.urlStatusCode;
            if (status === 404 || status === 410) {
              return { pageNotFound: true };
            }
            if (status === 401 || status === 403) {
              return { accessRestricted: true };
            }
            if (status === 408 || status === 504 || status === 0) {
              return { timeout: true };
            }
            if (status >= 400) {
              return { genericError: true };
            }
            return null;
          }),
          catchError(() => of({ timeout: true }))
        );
      })
    );
  }
  
  emptyUrlValidator(control: AbstractControl): ValidationErrors | null {
    if (this.isIndividualUrlVisible) return null;
      const val = (control.value || '').trim();
      return val.length === 0 ? { emptyUrl: true } : null;
  }

  urlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const url = control.value;
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/\S*)?$/;
    const isValid = urlPattern.test(url);
    if (!isValid) return { invalidUrl: true };
    return null;
  }

  // URL Input Management
  
  multiUrlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const urls = control.value
      .split(/[\n,]+/)
      .map(u => u.trim())
      .filter(Boolean);
    if (urls.length > 100) {
      return { maxUrlsExceeded: true };
    }

    if (urls.some(u => this.isNonHtmlResource(u))) {
      return { nonHtmlResource: true };
    }

    if (urls.some(u => u.length > 2048)) {
      return { urlTooLong: true };
    }

    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/\S*)?$/;
    const allValid = urls.every(url => urlPattern.test(url));
    if (!allValid) return { invalidUrl: true };
    try {
      const normalize = (url: string) =>
        url.startsWith("http://") || url.startsWith("https://")
          ? url
          : `https://${url}`;
      const getDomain = (url: string) => {
        let host = new URL(normalize(url)).hostname.toLowerCase();
        if (host.startsWith("www.")) {
          host = host.slice(4);
        }
        return host;
      };
      const firstDomain = getDomain(urls[0]);
      const allSameDomain = urls.every(url => getDomain(url) === firstDomain);
      if (!allSameDomain) {
        return { multipleDomainsNotAllowed: true };
      }
    } catch {
      return { invalidUrl: true }; 
    }
    return null;
  }
  parentUrlChange(): void {
    this.workflowForm.controls['individualUrls'].setValue('');
    const control = this.workflowForm.get('websiteUrl');
    control?.updateValueAndValidity();
    this.isParentUrlVisible = true;
    this.isIndividualUrlVisible = false;
  }

  individualUrlsChange(): void {
    this.workflowForm.controls['websiteUrl'].setValue('');
    const control = this.workflowForm.get('individualUrls');
    control?.updateValueAndValidity();
    this.isParentUrlVisible = false;
    this.isIndividualUrlVisible = true;
  }

  // Keywords Management
  sliceKeyword(keyword: string): string {
    return keyword.length > 15 ? `${keyword.slice(0, 12)}...` : keyword;
  }

  showKeywordInput(): void {
    this.keywordInputVisible = true;
    setTimeout(() => {
      this.inputElement?.nativeElement?.focus();
    }, 10);
  }

  addKeywordToSelectedKeywords(): void {
    if (this.selectedKeywordInputValue && this.allKeywords.length < this.maxKeywordsAllowed) {
      // Split the input by comma and process each keyword
      const keywordsToAdd = this.selectedKeywordInputValue.split(',')
        .map(keyword => keyword.trim())
        .filter(keyword => keyword.length > 0);

      // Add each keyword if it doesn't already exist and we're under the limit
      keywordsToAdd.forEach(keyword => {
        if (!this.allKeywords.includes(keyword) &&
          this.allKeywords.length < this.maxKeywordsAllowed) {
          this.allKeywords = [...this.allKeywords, keyword];
        }
      });
      this.listOfOption = this.allKeywords.map(k => ({ label: k, value: k }));
      this.selectedKeywordInputValue = '';
    }
    this.keywordInputVisible = false;
  }

  // Handle comma key press to add keywords instantly
  handleCommaKeyword(event: KeyboardEvent | Event): void {
    // Prevent the comma character from being added to the input
    if (event.preventDefault) {
      event.preventDefault();
    }
    
    // Get the current value from the input
    const value = this.selectedKeywordInputValue.trim();
    
    if (value && this.selectedKeywords.length < this.maxKeywordsAllowed) {
      // Add the current value as a keyword
      if (!this.selectedKeywords.includes(value)) {
        this.selectedKeywords = [...this.selectedKeywords, value];
      }
      
      // Reset input
      this.selectedKeywordInputValue = '';
    }
  }
  
  // Handle input changes to check for commas
  handleKeywordInput(event: InputEvent | Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // Check if the input contains a comma
    if (value.includes(',')) {
      // Split by comma and filter out empty strings
      const keywords = value.split(',').map(k => k.trim()).filter(k => k);
      
      // Add valid keywords to the list
      keywords.forEach((keyword) => {
        if (keyword && !this.allKeywords.includes(keyword) &&
          this.allKeywords.length < this.maxKeywordsAllowed) {
          this.allKeywords = [...this.allKeywords, keyword];
        }
      });
      
      // Always clear the input after processing comma-separated values
      // This ensures no extra text remains
      this.selectedKeywordInputValue = '';
      
      // Directly set the input value to empty
      if (input) {
        input.value = '';
      }
    }
  }

  removeKeyword(keyword: string, fromWebpagesTab: boolean = false): void {
    // Remove from selected/all keywords
    this.selectedKeywords = this.selectedKeywords.filter(item => item !== keyword);
    if (!fromWebpagesTab) {
      this.allKeywords = this.allKeywords.filter(item => item !== keyword);
    }

    // Update webpageKeywordMap:
    // - If a key's array only contains this keyword, remove the key.
    // - If it contains multiple, remove only this keyword from the array.
    if (this.webpageKeywordMap && typeof this.webpageKeywordMap === 'object') {
      let mutated = false;

      for (const key of Object.keys(this.webpageKeywordMap)) {
        const list = this.webpageKeywordMap[key];
        if (!Array.isArray(list)) continue;

        // Remove the keyword if present
        if (list.includes(keyword)) {
          const updated = list.filter(k => k !== keyword);
          if (updated.length === 0) {
            //delete this.webpageKeywordMap[key];
            this.webpageKeywordMap[key] = updated;
          } else {
            this.webpageKeywordMap[key] = updated;
          }
          mutated = true;
        } else {
          // Also remove keys that already have an empty array
          if (list.length === 0) {
            //delete this.webpageKeywordMap[key];
            this.webpageKeywordMap[key] = [];
            mutated = true;
          }
        }
      }

      // Reassign to trigger change detection if bound in template
      if (mutated) {
        this.webpageKeywordMap = { ...this.webpageKeywordMap };
      }
    }

     this.cdRef.detectChanges();
  }
  keywordTagsChange(): void {
    this.isKeywordTagsVisible = false;
    this.isKeywordUploadVisible = true;
  }

  keywordUploadChange(): void {
    this.isKeywordTagsVisible = true;
    this.isKeywordUploadVisible = false;
  }

  downloadKeywordSample(): void {
    this.campaignService.getKeywordDocumentSample(Number(this._storageHelper.user.bId)).pipe(takeUntil(this.destroy$)).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Keyword_Template.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => console.error('Failed to download keyword sample:', err)
    });
  }
  // File Upload Management
  
  //Upload
  contentAnalysisStatus = '';
  fileList = [];
  @ViewChild('ErrorAlertTemplate') ErrorAlertTemplate!: TemplateRef<any>;
  handleChange({ file, fileList }: MwcUploadChangeParam): void {
    const status = file.status;
    if (status !== 'uploading') {
    }
    if (status === 'done') {
      this.fileList = [{
        uid: '-xxx',
        percent: 100,
        name: file.name,
        status: 'done',
      }];
      //this.msg.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.fileList = [{
        uid: '-xxx',
        percent: 100,
        name: file.name,
        status: 'error',
      }];
      //this.msg.error(`${file.name} file upload failed.`);
    }
  }
  beforeUpload = (file: MwcUploadFile): boolean => {
    file.status = 'uploading';
    file.percent = 50;
    this.fileList = [];
    this.fileList.push(file);
    this.fileList = [...this.fileList];
    let uploadedFile: any = file;
    const reader = new FileReader();

    reader.onload = () => {
      // This is where the content of the file will be available.
      this.uploadFile(file);
    };

    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };

    // Read the file as text
    reader.readAsText(uploadedFile);
    return false;
  }
  formDataForFile = new FormData();

  hasValidExtension(fileName: string, allowedExtensions: string[]): boolean {
    const regex = new RegExp(`\\.(${allowedExtensions.join('|')})$`, 'i');
    return regex.test(fileName);
  }


  uploadFile(file: any) {
    let fr = new FileReader();    

    if (this.fileList && this.fileList[0] && this.fileList.length > 0) {

      const allowedExtensions = ['xlsx', 'xls'];
      if (!this.hasValidExtension(this.fileList[0].name, allowedExtensions)) {
        this.fileList = [];        
        this.notification.snackbarError('Invalid supported file, Only xlsx and xls file allowed.');
        this.cdRef.detectChanges();
        return;
      }
      const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
      var fileSize = this.fileList[0].size;
      if (fileSize > MAX_FILE_SIZE) {
        this.fileList = [];
        /*  this.errorMessage = "File size exceeds the 10MB limit. Please upload a smaller file.";
        this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'top', mwcClass: 'error-notification-content' }); */
        this.notification.snackbarError('File size exceeds the 10MB limit. Please upload a smaller file.');
        this.cdRef.detectChanges();
        return;
      }      
      this.formDataForFile.set('file', this.fileList[0], this.fileList[0].name);
    }
    const totalDuration = 2000; // 2 seconds
    const steps = 20; // Number of updates (can be increased for smoother animation)
    const stepTime = totalDuration / steps; // Time for each step (milliseconds)
    this.contentAnalysisStatus = 'analyzing';
    interval(stepTime)
      .pipe(take(steps + 1)) // Run the interval 20 times (0% to 100%)
      .subscribe((step) => {
        const percentDone = Math.min((step / steps) * 100, 100); // Calculate progress
        if (percentDone == 100) {
          this.contentAnalysisStatus = '';
        }
        if (this.fileList.length > 0) {
          this.fileList[0].percent = Math.round(percentDone);
          this.fileList[0].status = percentDone === 100 ? 'done' : 'uploading';
          this.fileList = [...this.fileList];          
          this.cdRef.detectChanges();
        }
      });
    this.UploadKeywords();
    
  }
  
  UploadKeywords() {
    const uploadedKeywordFile = this.fileList[0];
    this.campaignService.uploadKeywordDocument(uploadedKeywordFile).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          const data = response.data;
          // Retain the uploaded keyword sheet so it can be stored to blob during generation
          this.keywordDocumentFile = uploadedKeywordFile;

          this.allKeywords = (data.keywords || []).reduce((acc: string[], row) => acc.concat(row.keywords || []), []);

          this.webpageKeywordMap = {};
          (data.keywords || []).forEach(row => {
            if (row.pageName) {
              this.webpageKeywordMap[row.pageName] = row.keywords || [];
            }
          });

          this.keywordDocumentData = data;
          this.keywordUploadChange();
        } else if (!response.success && response.message) {
          this.fileList = [];
          this.keywordDocumentFile = null;
          this.cdRef.detectChanges();
          this.notification.snackbarError(response.message);
        }
      },
      error: (err) => {
        console.error('keyword upload failed:', err);
        this.fileList = [];
        this.keywordDocumentFile = null;
        this.cdRef.detectChanges();
      },
    });
  }

  // Navigation and Workflow Control
  onNext(): void {
    // Validate current tab before proceeding
    if (this.selectedIndex === 0) {
      // Validate website URL
      if (this.isParentUrlVisible) {
        const websiteUrl = this.workflowForm.get('websiteUrl')?.value;
        if (!websiteUrl) {
          // Display validation error
          this.workflowForm.get('websiteUrl')?.markAsTouched();
          return;
        }
      } else if (this.isIndividualUrlVisible) {
        const individualUrls = this.workflowForm.get('individualUrls')?.value;
        if (!individualUrls) {
          // Display validation error
          this.workflowForm.get('individualUrls')?.markAsTouched();
          return;
        }
      }

      // Enable the next tab
      this.tabs[1].disable = false;
      
      // Mark current tab as completed
      this.tabs[0].completed = true;
      
      // Move to next tab
      this.selectedIndex = 1;
    } else {
      // Enable the next tab if it exists
      if (this.selectedIndex <= this.tabs.length - 1) {
        this.tabs[this.selectedIndex + 1].disable = false;
        
        // Mark current tab as completed
        this.tabs[this.selectedIndex].completed = true;
        
        // Move to next tab
        this.selectedIndex += 1;
      }
    }
  }

  proceedFromKeywords(): void {
    const keywordsControl = this.workflowForm.get('keywords');
    const trimmedKeywords = this.allKeywords
      .map(k => k.trim())
      .filter(k => !!k);
    if (!trimmedKeywords.length) {
      console.warn('No valid keywords selected.');
      return;
    }
    this.listOfOption = trimmedKeywords.map(k => ({ label: k, value: k }));

    keywordsControl?.setValue(trimmedKeywords.join(', '));
    const request: WebpageKeywordTemplateMappingRequest = {
      BrandId: this.brandSelectedValue ?? null,
      Keywords: trimmedKeywords,
      WebpageKeywords:this.webpageKeywordMap
    };
    this.keywordAnalysisinProgress = true;
    this.generationInProgressHelperService.openWaitingPopup([], 'Analysis in Progress...');
    this.getTemplates();
    this.campaignService.WebpageKeywordTemplateMapping(request).subscribe({
      next: (response: WebpageKeywordTemplateMappingResponse) => {
        this.keywordAnalysisinProgress = false;
        this.generationInProgressHelperService.closeTemplateSelector();
        if (!response?.success) {
          console.error('Keyword mapping failed:', response?.message || 'Unknown error');
          return;
        }
        this.onNext();
        if (response && response.webpageKeywordTemplateMappings != null) {
          if (response.webpageKeywordTemplateMappings.length > 0) {
            this.pages = [];
            response.webpageKeywordTemplateMappings.forEach((data) => {
              this.onItemChecked(this.pageData.length + 1, true);
              const newSection = {
                id: this.pageData.length + 1,
                title: data.webPageName,
                url: '',
                keywords: data.keywords,
                template: data.templateId,
                disabled: false
              };
              this.pages.push(newSection);
            });
            this.cdRef.detectChanges();
          }
        }
        this.tabs[1].completed = true;
        this.cdRef.detectChanges();
      },
      error: (err) => {
        this.keywordAnalysisinProgress = false;
        this.generationInProgressHelperService.closeTemplateSelector();
        console.error('API call failed:', err);
      }
    });
  }

  // proceedFromKeywords(): void {
  //   this.workflowForm.get('keywords').setValue(this.selectedKeywords.join(', '));
  //   const keywords = this.selectedKeywords.map(k => k.trim()).filter(k => k);
  //   let urls: string[] = [];
  //   const individualUrlsRaw = this.workflowForm.get('individualUrls')?.value;
  //   const websiteUrl = this.workflowForm.get('websiteUrl')?.value;
  //   if (individualUrlsRaw && individualUrlsRaw.trim()) {
  //     urls = individualUrlsRaw
  //       .split(/[\n,]/)
  //       .map(u => u.trim())
  //       .filter(u => u)
  //       .map(u => u.startsWith('http://') || u.startsWith('https://') ? u : `https://${u}`)
  //       .map(u => {
  //         try {
  //           return new URL(u).origin + new URL(u).pathname; // removes query + hash
  //         } catch {
  //           return u; // fallback if invalid URL
  //         }
  //       });
  //   } else if (websiteUrl && websiteUrl.trim()) {
  //     urls = [
  //       websiteUrl.trim().startsWith('http://') || websiteUrl.trim().startsWith('https://')
  //         ? websiteUrl.trim()
  //         : `https://${websiteUrl.trim()}`
  //     ];

  //     urls = urls.map(u => {
  //       try {
  //         return new URL(u).origin + new URL(u).pathname; // removes query + hash
  //       } catch {
  //         return u; // fallback if invalid URL
  //       }
  //     });
  //   }
  //   const request: AnalyzeUrlsRequest = {
  //     urls: urls,
  //     keywords: keywords,
  //     profileId: this._storageHelper.user.pId,
  //     businessId: Number(this._storageHelper.user.bId),
  //     profileName: this._storageHelper.user.profileName,
  //     isIndividualUrls: !!individualUrlsRaw && individualUrlsRaw.trim().length > 0,
  //     brandId: this.brandSelectedValue || null
  //   };
  //   this.keywordAnalysisinProgress = true;
  //   //commented for new changes
  //   //this.waitingScreenforAnalysis = true;
  //   //this.isGoToCampaignsEnabled = false;
  //   const startTime = Date.now();
    
  //    this.campaignService.AnalyzeUrls<AnalyzeUrlsResponse>(request).subscribe({
  //     next: (response: AnalyzeUrlsResponse) => {
  //       //this.isGoToCampaignsEnabled = true;
  //       this.cdRef.detectChanges();
  //       if (response && response.success) {
  //         this.tabs[1].completed = true;
  //         this.tracking.trackEvent(
  //           'action',
  //           `Workflow - Proceed to ${this.tabs[2].name}`
  //         );
  //         const elapsed = Date.now() - startTime;
  //         const delay = Math.max(0, 7000 - elapsed);
  //         setTimeout(() => {
  //           this.keywordAnalysisinProgress = false;
  //           this.onNext();
  //           this.cdRef.detectChanges();
  //           /* this.waitingScreenforAnalysis = false;
  //           this.modalService.closeAll();
  //           this.cdRef.detectChanges();
  //           if (this.router.url === "/campaigns/my-campaigns") {
  //             this.campaignService.triggerReload();
  //           } else {
  //             this.router.navigateByUrl("/campaigns/my-campaigns");
  //           } */
  //         }, delay);
  //       } else {
  //         console.error('Analysis failed:', response?.message);
  //       }
  //     },
  //     error: (err) => {
  //       this.waitingScreenforAnalysis = false;
  //       this.modalService.closeAll();
  //       console.error('Error calling AnalyzeUrls API', err);
  //     }
  //   });
  // }

  goToMyCampaigns(){
    this.modalService.closeAll();
    if (this.router.url === "/campaigns/my-campaigns") {
      this.campaignService.triggerReload();
    } else {
      this.router.navigateByUrl("/campaigns/my-campaigns");
    }
  }
  // proceedFromKeywords(): void {
  //   this.modalService.closeAll();
  //   this.router.navigate(['/campaigns/my-campaigns']);
  // }




  onChangeWorkflow(): void {
    // Logic to change workflow
    this.modalRef.close(null);
  }

  // onSubmit(): void {
  //   // Show loading state
  //   this.isLoading = true;
    
  //   // Simulate form submission
  //   setTimeout(() => {
  //     this.isLoading = false;
  //     // Handle form submission success
  //   }, 2000);
  // }

  getRandomItems = (list: any[], count: number): any[] => {
    const shuffled = list.sort(() => 0.5 - Math.random()); // Shuffle the list
    return shuffled.slice(0, count); // Return the first `count` items
  };

  onSubmit(): void {
  if (!this.workflowForm.valid) {
    return;
  }
  this.isLoading = true;  
  const campaignRequest = new GenerateCampaignArticlesRequest();
  campaignRequest.campaignId = this.campaignId || null;
  campaignRequest.CampaignTopic = this.campaignName || "";
  campaignRequest.CampaignGoal = this.workflowForm.get('campaignGoal')?.value || "";
  campaignRequest.contentBrief = this.workflowForm.get('contentBrief')?.value || "";
  campaignRequest.tone = this.workflowForm.get('tone')?.value || "";
  const selectedTemplates = this.pages.filter(x => this.setOfCheckedId.has(x.id));
  campaignRequest.Templates = selectedTemplates.map(t =>
    this.createTemplate({
      title: this.templates.find(x => x.id === t.template)?.name || '',
      CustomTemplateId: t.template,
      PageTitle: t.title,
      templateId: 32,
      Keywords: t.keywords
    })
  );
  campaignRequest.targetAudienceId = this.workflowForm.get('targetAudienceId')?.value;
  campaignRequest.brandVoiceId = this.workflowForm.get('brandVoiceId')?.value;
  const selectedLanguage = this.provinceData.find(x => x.value === this.selectedValueLanguage);
  if (selectedLanguage) {
    const languageDetail = new DocumentLanguage();
    languageDetail.id = selectedLanguage.id;
    languageDetail.countryCode = selectedLanguage.value;
    languageDetail.languageName = selectedLanguage.label;
    languageDetail.languageCode = selectedLanguage.languageCode;
    campaignRequest.languageDetail = languageDetail;
    campaignRequest.language = selectedLanguage.label;
  }
  campaignRequest.pages = this.pages.map(t => {
    const temp = new PageConfiguration();
    temp.title = t.title;
    temp.pageUrl = t.url;
    temp.templateId = t.template;
    temp.keywords = t.keywords;
    return temp;
  });
  let tIdea = new topicIdea();
  tIdea.keywords = this.keywordListFromAddKeywordTab;
  tIdea.pillarIdea = "";
  campaignRequest.topicIdea = tIdea;  
  this.modalRef.close(null);
  this.generationInProgressHelperService.openWaitingPopup(this.getRandomItems([], 3), 'Generation in progress...', false, false, true);
  const startTime = Date.now();
    campaignRequest.brandId = this.brandSelectedValue || null;
  this.campaignService.GenerateCampaignArticlesForCustomTemplate(campaignRequest).pipe(
    finalize(() => this.isLoading = false)
  ).subscribe({
    next: (res) => {
      const campaignData = new CampaignData();
      campaignData.campaignId = res.campaignId;
      campaignData.CampaignTopic = campaignRequest.CampaignTopic;
      campaignData.createddate = this.formatDate(new Date());
      this.articleStoreService.updateCampaignState(campaignData);
      const navigationExtras: any = {
        queryParams: res.campaignId ? { campaignId: res.campaignId } : {}
      };
      const elapsed = Date.now() - startTime;
      const delay = Math.max(0, 10000 - elapsed);
      setTimeout(() => {
        this.modalService.closeAll();
        this.campaignService.triggerReload();
        this.cdRef.detectChanges();
      }, delay);
    },
    error: (err) => {
      console.error("GenerateCampaignArticles error:", err);
      this.modalService.closeAll();
      this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, err, null, null)
    }
  });
}

  onSubmitNew(): void {
    if (!this.workflowForm.valid) {
      return;
    }
    this.isLoading = true;
    let urls: string[] = [];
    const individualUrlsRaw = this.workflowForm.get('individualUrls')?.value;
    //const websiteUrl = this.workflowForm.get('websiteUrl')?.value;
    const websiteUrl = this.urlToCrawl;
    if (individualUrlsRaw && individualUrlsRaw.trim()) {
      urls = individualUrlsRaw
        .split(/[\n,]/)
        .map(u => u.trim())
        .filter(u => u)
        .map(u => u.startsWith('http://') || u.startsWith('https://') ? u : `https://${u}`)
        .map(u => {
          try {
            return new URL(u).origin + new URL(u).pathname; // removes query + hash
          } catch {
            return u; // fallback if invalid URL
          }
        });
    } else if (websiteUrl && websiteUrl.trim()) {
      urls = [
        websiteUrl.trim().startsWith('http://') || websiteUrl.trim().startsWith('https://')
          ? websiteUrl.trim()
          : `https://${websiteUrl.trim()}`
      ];

      urls = urls.map(u => {
        try {
          return new URL(u).origin + new URL(u).pathname; // removes query + hash
        } catch {
          return u; // fallback if invalid URL
        }
      });
    }
    const campaignRequest = new GenerateCampaignArticlesForCustomTemplateRequest();
    campaignRequest.highlights = this.highlights;
    campaignRequest.keywordDocumentData = this.keywordDocumentData ?? undefined;
    campaignRequest.keywordDocumentFile = this.keywordDocumentFile ?? undefined;
    campaignRequest.campaignId = this.campaignId || null;
    campaignRequest.CampaignTopic = this.campaignName || "";
    campaignRequest.CampaignGoal = this.workflowForm.get('campaignGoal')?.value || "";
    campaignRequest.contentBrief = this.workflowForm.get('contentBrief')?.value || "";
    campaignRequest.tone = this.workflowForm.get('tone')?.value || "";
    const selectedTemplates = this.pages.filter(x => this.setOfCheckedId.has(x.id));
    campaignRequest.Templates = selectedTemplates.map(t =>
      this.createTemplate({
        title: this.templates.find(x => x.id === t.template)?.name || '',
        CustomTemplateId: t.template,
        PageTitle: t.title,
        templateId: 32,
        Keywords: t.keywords
      })
    );
    campaignRequest.targetAudienceId = this.workflowForm.get('targetAudienceId')?.value;
    campaignRequest.brandVoiceId = this.workflowForm.get('brandVoiceId')?.value;
    const selectedLanguage = this.provinceData.find(x => x.value === this.selectedValueLanguage);
    if (selectedLanguage) {
      const languageDetail = new DocumentLanguage();
      languageDetail.id = selectedLanguage.id;
      languageDetail.countryCode = selectedLanguage.value;
      languageDetail.languageName = selectedLanguage.label;
      languageDetail.languageCode = selectedLanguage.languageCode;
      campaignRequest.languageDetail = languageDetail;
      campaignRequest.language = selectedLanguage.label;
    }
    campaignRequest.pages = this.pages.map(t => {
      const temp = new PageConfiguration();
      temp.title = t.title;
      temp.pageUrl = t.url;
      temp.templateId = t.template;
      temp.keywords = t.keywords;
      return temp;
    });
    let tIdea = new topicIdea();
    tIdea.keywords = this.allKeywords.map(k => k.trim()).filter(k => k);;
    tIdea.pillarIdea = "";
    campaignRequest.topicIdea = tIdea;    
    this.modalRef.close(null);
    this.generationInProgressHelperService.openWaitingPopup(this.getRandomItems([], 3), 'Generation in progress...', false, false, true);
    const startTime = Date.now();
    campaignRequest.brandId = this.brandSelectedValue || null;
    campaignRequest.keywords = this.allKeywords.map(k => k.trim()).filter(k => k);
    campaignRequest.profileName = this._storageHelper.user.profileName;
    campaignRequest.profileId = this._storageHelper.user.pId;
    campaignRequest.businessId = Number(this._storageHelper.user.bId);
    campaignRequest.isIndividualUrls = !!individualUrlsRaw && individualUrlsRaw.trim().length > 0;
    campaignRequest.urls = urls;
    campaignRequest.files = this.uploadedFiles;
    this.campaignService.GenerateCampaignArticlesForCustomTemplateNew(campaignRequest).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe({
      next: (res) => {
        const campaignData = new CampaignData();
        campaignData.campaignId = res.campaignId;
        campaignData.CampaignTopic = campaignRequest.CampaignTopic;
        campaignData.createddate = this.formatDate(new Date()); 
        this.articleStoreService.updateCampaignState(campaignData);
        if (res.status == 'Queued') {
          this.notification.snackbarSuccess('You have ' + res.activeCount + ' projects currently in progress. This new project will start automatically once one of them is complete.');
        }
        const navigationExtras: any = {
          queryParams: res.campaignId ? { campaignId: res.campaignId } : {}
        };
        const elapsed = Date.now() - startTime;
        const delay = Math.max(0, 10000 - elapsed);
        setTimeout(() => {
          // goToMyCampaigns() triggers the reload itself (or navigates, which loads fresh data)
          this.goToMyCampaigns();
          this.cdRef.detectChanges();
        }, delay);
      },
      error: (err) => {
        console.error("GenerateCampaignArticles error:", err);
        this.modalService.closeAll();
        this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, err, null, null)
      }
    });
  }
  private createTemplate(partial: Partial<Template>): Template {
    return {
      title: '',
      description: '',
      icon: '',
      iconColor: 'primary',
      type: 'web',
      titleText: '',
      placeholderText: '',
      contentBriefText: '',
      isPublishable: false,
      recentlyUsed: false,
      summary: '',
      whyUse: [],
      isFavorite: false,
      templateCategories: [],
      CustomTemplateId: null,
      ...partial
    } as Template;
  }

  formatDate(isoString) {
    const date = new Date(isoString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getUTCFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // covers 11-20
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  }

  // Additional properties needed for content instructions tab
  uploadedFiles: any[] = [];
  maxDocuments = 3;
  documentTypeOptions = [
    { label: 'Brand Document', value: 'brandDocument' },
    { label: 'Information Document', value: 'informationDocument' },
    /* { label: 'Business Guidelines', value: 'businessGuidelines' },
    { label: 'Keywords List', value: 'keywordsList' }, */
    { label: 'Other - Please Specify', value: 'other' }
  ];
  templateOptions = [];
  listOfOption = [];
  
  // For Table actions
  setOfCheckedId = new Set<number>();
  
  
  isKeywordSelected(keyword: string): boolean {
    return this.selectedKeywords.includes(keyword);
  }
  
  toggleKeywordSelection(keyword: string): void {
    if (this.isKeywordSelected(keyword)) {
      this.removeKeyword(keyword, true);
    } else if (this.selectedKeywords.length < this.maxKeywordsAllowed) {
      this.selectedKeywords.push(keyword);
    }
  }
  
  // Utility methods
  reloadList(event: string) {
    console.log(`Reload ${event} list clicked`);
    this.tracking.trackEvent(
      'action', `Reload ${event} list clicked`
    );
    if (event == "targetAudience") {
      this.fetchTargetAudiences(true);
    } else {
      this.fetchBrandVoices(true);
    }
  }



  //Brand Voice
  fetchBrandVoices(isReload: boolean = false) {
    if (isReload) { this.filteredBrandVoiceList = []; this.brandVoiceList = []; }
    var brandVoiceListRequest = new GetBrandVoiceListRequest();
    brandVoiceListRequest.profileId = +this._storageHelper.user.pId;

    this.isLoading = true;
    this.articleService.GetBrandVoiceList(brandVoiceListRequest).subscribe((response: GetBrandVoiceListResponse) => {
      console.log(response);
      if (response.errorCode != 0 && !response.errorMessage) {
        //show error messages
      } else {
        if (response.totalRecords > 0) this.isNoCreateBrandVoice = false;
        response.brandVoices.forEach((brandVoice: BrandVoice) => {
          if (brandVoice.isDefault) {
            this.isDefaultBVAvailable = true;
            this.defaultBVId = brandVoice.brandVoiceId;
          }
          this.brandVoiceList.push({
            label: brandVoice.title, value: brandVoice.brandVoiceId.toString(), tone: brandVoice.thingBrandVoice.thingJson.voiceTone, createdOn: brandVoice.createdDate.toString(), createdBy: brandVoice.authorName, brandVoiceDocument: brandVoice.thingBrandVoice.thingJson.brandVoiceDocument, details: brandVoice.thingBrandVoice.thingJson, isDefault: brandVoice.isDefault, isSelectedBV: false
          })
        });
        this.filteredBrandVoiceList = this.brandVoiceList;
        let data;
        if (this.isDefaultBVAvailable && this.defaultBVId != 0) {
          //if (!this.isRegenerateFlow) {
          //  data = this.brandVoiceList.filter(item => { if (item.value == this.defaultBVId.toString()) return item })[0];
          //} else {
            data = this.brandVoiceList.filter(item => { if (item.value == this.defaultBVId) return item })[0];
            this.filteredBrandVoiceList = this.filteredBrandVoiceList.map(item => ({
              ...item,
              isDefault: item.isDefault,
              isSelectedBV: item.value === this.defaultBVId
            }));
          //}

          if (data != null && data != undefined) {
            this.brandVoiceDetails = data;
            this.workflowForm.patchValue(
              {
                brandVoiceDocument: data.brandVoiceDocument,
                brandVoiceDetails: data.details,
                brandVoiceId: +data.value
              }
            );
            this.selectedBrandVoice = data.value;
          }
        }
        //if (this.campaignData != null && this.campaignData.brandVoiceId != 0) {
        //  let data = this.brandVoiceList.filter(item => { if (item.value == this.campaignData.brandVoiceId.toString()) return item })[0];
        //  if (data != null && data != undefined) {
        //    this.isDefaultBVAvailable = false;
        //    this.defaultBVId = 0;
        //    this.brandVoiceDetails = data;
        //    this.generateAiForm.patchValue(
        //      {
        //        brandVoiceDocument: data.brandVoiceDocument,
        //        brandVoiceDetails: data.details,
        //        brandVoiceId: +data.value
        //      }
        //    );
        //    this.selectedBrandVoice = data.value;
        //    this.filteredBrandVoiceList = this.filteredBrandVoiceList.map(item => ({
        //      ...item,
        //      isDefault: false,
        //      isSelectedBV: item.value === this.campaignData.brandVoiceId.toString()
        //    }));
        //  }
        //}
      }
      this.isLoading = false;
    }, (error: any) => {
      this.isLoading = false;
    });
  }
  selectBV(value) {
    this.selectedBrandVoice = value;
    this.brandVoiceChange(value);
    this.isShowDetailsBV = true;
    let data = this.filteredBrandVoiceList.filter(item => { if (item.value == value) return item })[0];
    if (data != null && data != undefined) {
      if (data.isDefault) {
        this.isDefaultBVAvailable = true;
      }
      else {
        this.isDefaultBVAvailable = false;
      }
    }

    // Update form control
    this.workflowForm.get('brandVoice').setValue(data.label);

    // Track selection
    this.tracking.trackEvent(
      'action', `Selected Brand Voice: ${data.label}`
    );
  }

  brandVoiceChange(event) {
    let data = this.brandVoiceList.filter(item => { if (item.value == event) return item })[0];
    if (data != null && data != undefined) {
      this.brandVoiceDetails = data;
      this.workflowForm.patchValue(
        {
          brandVoiceDocument: data.brandVoiceDocument,
          brandVoiceDetails: data.details,
          brandVoiceId: +data.value
        }
      );
    }
  }

  changeBV() {
    this.isShowDetailsBV = false;
  }
  SelectedBV(value) {
    let data = this.brandVoiceList.filter(item => { if (item.value == value) return item })[0];
    if (data != null && data != undefined) {
      this.filteredBrandVoiceList = [];
      this.brandVoiceList.forEach((brandVoice) => {
        if (brandVoice.value == value) {
          this.filteredBrandVoiceList.push({
            label: brandVoice.label, value: brandVoice.value, tone: brandVoice.tone, createdOn: brandVoice.createdOn, createdBy: brandVoice.createdBy, brandVoiceDocument: brandVoice.brandVoiceDocument, details: brandVoice.details, isDefault: true, isSelectedBV: true
          })
          this.isDefaultBVAvailable = true;
          this.selectedBrandVoice = value;
          this.brandVoiceDetails = data;
          this.workflowForm.patchValue(
            {
              brandVoiceDocument: data.brandVoiceDocument,
              brandVoiceDetails: data.details,
              brandVoiceId: +data.value
            }
          );
        }
        else {
          this.filteredBrandVoiceList.push({
            label: brandVoice.label, value: brandVoice.value, tone: brandVoice.tone, createdOn: brandVoice.createdOn, createdBy: brandVoice.createdBy, brandVoiceDocument: brandVoice.brandVoiceDocument, details: brandVoice.details, isDefault: false, isSelectedBV: false
          })
        }
      });
    }
  }
  triggerSearchBV() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchBrandVoice(this.searchTxt);
    }, 1000);
  }

  searchBrandVoice(searchText: string = "") {
    const query = searchText.toLowerCase();
    this.filteredBrandVoiceList = this.brandVoiceList.filter(s => s.tone.toLowerCase().includes(query) || s.label.toLowerCase().includes(query) || s.createdBy.toLowerCase().includes(query));
    if (this.filteredBrandVoiceList.length == 0) {
      this.FoundSerchBV = false;
      this.filteredBrandVoiceList = this.brandVoiceList;
    }
    else {
      this.FoundSerchBV = true;
      this.filteredBrandVoiceList = [...this.filteredBrandVoiceList];
    }
    this.cdRef.detectChanges();
  }

  openRedirectToMPC(event) {
    if (event == 'targetAudience') {
      const route = this.router.createUrlTree(['/target-audience']);
      const url = this.router.serializeUrl(route);
      window.open(url, '_blank');
    } else {
      const route = this.router.createUrlTree(['/brand-voice']);
      const url = this.router.serializeUrl(route);
      window.open(url, '_blank');
    }
    //this.newTemplateHelperService.closeTemplateSelector();
    //this.modal.destroy();
  }

  getDaysDifference(inputDate) {
    // Convert input date to a Date object
    const date = new Date(inputDate);
    // Get today's date
    const today = new Date();

    // Reset time components to compare only dates
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    // Calculate difference in milliseconds
    const timeDifference = Math.abs(today.getTime() - date.getTime());

    // Convert milliseconds to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    // Format the result
    if (daysDifference === 0) {
      return "Today";
    } else if (daysDifference === 1) {
      return "1 day ago";
    } else {
      return `${daysDifference} days ago`;
    }
  }

  //Target Audience
  fetchTargetAudiences(isReload: boolean = false) {
    if (isReload) this.targetAudienceList = []; this.filteredTargetAudienceList = [];
    var targetAudienceListRequest = new GetTargetAudienceListRequest();
    targetAudienceListRequest.profileId = +this._storageHelper.user.pId;

    this.isLoading = true;
    this.articleService.GetTargetAudienceList(targetAudienceListRequest).subscribe((response: GetTargetAudienceListResponse) => {
      console.log(response);
      if (response.errorCode != 0 && !response.errorMessage) {
        //show error messages
      } else {
        if (response.totalRecords > 0) this.isNoTargetAudience = false;
        //this.isNoTargetAudience = true;
        response.targteAudiences.forEach((targetAudience: TargetAudience) => {
          if (targetAudience.isDefault) {
            this.isDefaultTAAvailable = true;
            this.defaultTAId = targetAudience.targetAudienceId;
          }
          this.targetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": targetAudience.isDefault,
            "isSelectedTA": false
          });
        });
        this.filteredTargetAudienceList = this.targetAudienceList;
        //if (this.isRegenerateFlow) {
        //  this.defaultTAId = this.mwcModalData.AIData.topicIdea.taId;
        //  this.filteredTargetAudienceList = this.filteredTargetAudienceList.map(item => ({
        //    ...item,
        //    isDefault: false,
        //    isSelectedTA: item.targetAudienceId === this.mwcModalData.AIData.topicIdea.taId
        //  }));
        //}
        if (this.isDefaultTAAvailable && this.defaultTAId != 0) {
          let data = this.targetAudienceList.filter(item => { if (item.targetAudienceId == this.defaultTAId) return item })[0];
          if (data != null && data != undefined) {
            this.targetAudienceDetails = data;
            this.workflowForm.patchValue(
              {
                targetAudienceDetails: data.thingTargetAudience.thingJson,
                targetAudienceId: +data.targetAudienceId
              }
            );
          }
          this.selectedTargetAudience = data.title;
        }
        //if (this.campaignData != null && this.campaignData.targetAudienceId != 0) {
        //  let data = this.targetAudienceList.filter(item => { if (item.targetAudienceId == this.campaignData.targetAudienceId) return item })[0];
        //  if (data != null && data != undefined) {
        //    this.isDefaultTAAvailable = false;
        //    this.defaultTAId = 0;
        //    this.targetAudienceDetails = data;
        //    this.generateAiForm.patchValue(
        //      {
        //        targetAudienceDetails: data.thingTargetAudience.thingJson,
        //        targetAudienceId: +data.targetAudienceId
        //      }
        //    );
        //  }
        //  this.selectedTargetAudience = data.title;
        //  this.filteredTargetAudienceList = this.filteredTargetAudienceList.map(item => ({
        //    ...item,
        //    isDefault: false,
        //    isSelectedTA: item.targetAudienceId === this.campaignData.targetAudienceId
        //  }));
        //}
      }
      this.isLoading = false;
    }, (error: any) => {
      this.isLoading = false;
    });
  }
  viewAllTA() {
    this.isShowDetailsTA = false;
  }
  selectTV(value) {
    this.selectedTargetAudience = value;
    this.targetAudienceChange(this.selectedTargetAudience);
    this.isShowDetailsTA = true;
    let data = this.filteredTargetAudienceList.filter(item => { if (item.title == value) return item })[0];
    if (data != null && data != undefined) {
      if (data.isDefault) {
        this.isDefaultTAAvailable = true;
      }
      else {
        this.isDefaultTAAvailable = false;
      }
    }
  }
  
  targetAudienceChange(event) {
    this.tracking.trackEvent(
      'pageview', 'Target Audience Dropdown Selection'
    );
    let data = this.targetAudienceList.filter(item => { if (item.title == event) return item })[0];
    if (data != null && data != undefined) {
      this.targetAudienceDetails = data;
      this.workflowForm.patchValue(
        {
          targetAudienceDetails: data.thingTargetAudience.thingJson,
          targetAudienceId: +data.targetAudienceId
        }
      );
    }
  }
  SelectedTA(value) {
    let data = this.targetAudienceList.filter(item => { if (item.title == value) return item })[0];
    if (data != null && data != undefined) {
      this.filteredTargetAudienceList = [];

      this.targetAudienceList.forEach((targetAudience) => {
        if (targetAudience.title == value) {
          this.filteredTargetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.thingTargetAudience.thingJson.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": true,
            "isSelectedTA": true
          });
          this.isDefaultTAAvailable = true;
          this.selectedTargetAudience = value;
          this.targetAudienceDetails = data;
          this.workflowForm.patchValue(
            {
              targetAudienceDetails: data.thingTargetAudience.thingJson,
              targetAudienceId: +data.targetAudienceId
            }
          );
        }
        else {
          this.filteredTargetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.thingTargetAudience.thingJson.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": false,
            "isSelectedTA": false
          });
        }
      });
    }
  }
  triggerSearchTA() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchTargetAudience(this.searchTxt);
    }, 1000);
  }

  searchTargetAudience(searchText: string = "") {
    const query = searchText.toLowerCase();
    this.filteredTargetAudienceList = this.targetAudienceList.filter(s => {
      const titleMatch = s.title.toLowerCase().includes(query);
      const authorMatch = s.authorName.toLowerCase().includes(query);
      const genderMatch = s.thingTargetAudience?.thingJson?.gender?.some((g: string) =>
        g.toLowerCase().includes(query)
      );
      const ageGroupMatch = s.thingTargetAudience?.thingJson?.ageGroup?.some((ag: string) =>
        ag.toLowerCase().includes(query)
      );
      return titleMatch || authorMatch || genderMatch || ageGroupMatch;
    });
    this.FoundSearchTA = this.filteredTargetAudienceList.length > 0;
    if (!this.FoundSearchTA) {
      this.filteredTargetAudienceList = this.targetAudienceList;
    }
    this.cdRef.detectChanges();
  }
  
  // language methods
  languageChanged(lang) {
    this.tracking.trackEvent(
      'pageview', 'Selection: Language'
    );
  }


  // Pages configuration methods
  get pageData() {
    return this.pages;
  }
  // Method to handle adding a new keyword to a page
  addKeywordToPage(pageIndex: number): void {
    this.activePageIndex = pageIndex;
    // Initialize selected keywords with the ones already on the page
    this.selectedKeywords = [...this.pages[pageIndex].keywords];
    this.openNewInputTag();
  }
  
  // Method to cancel keyword selection and close dropdown
  cancelKeywordSelection(): void {
    // Close dropdown using DOM API
    this.closeDropdown();
    this.selectedKeywords = [];
    this.activePageIndex = null;
    this.newTagText = '';
    this.isDuplicateKeyword = false;
    this.showTagInput = false;
  }
  
  // Method to add selected keywords to the page and close dropdown
  confirmKeywordSelection(): void {
    if (this.activePageIndex !== null && this.selectedKeywords.length > 0) {
      // Replace the page's keywords with the selected ones
      this.pages[this.activePageIndex].keywords = [...this.selectedKeywords];
      // Track the action
      this.tracking.trackEvent(
        'action', `Added ${this.selectedKeywords.length} keywords to page ${this.pages[this.activePageIndex].title}`
      );
    }
    
    // Close dropdown using DOM API
    this.closeDropdown();
    this.selectedKeywords = [];
    this.activePageIndex = null;
  }
  
  // Helper method to close dropdown
  private closeDropdown(): void {
    // Use DOM API to click outside the dropdown
    setTimeout(() => {
      document.body.click();
    }, 0);
  }
  // Table Management
  onAllChecked(checked: boolean): void {
    this.pages.forEach(page => {
      if (checked) {
        this.setOfCheckedId.add(page.id);
      } else {
        this.setOfCheckedId.delete(page.id);
      }
    });
    this.refreshCheckedStatus();
  }

  // Handle individual item checked
  onItemChecked(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
    this.refreshCheckedStatus();
  }

  // Refresh the checked status
  refreshCheckedStatus(): void {
    const listOfEnabledData = this.pages.filter(page => !page.disabled);
    this.checked = listOfEnabledData.every(page => this.setOfCheckedId.has(page.id));
    this.indeterminate = listOfEnabledData.some(page => this.setOfCheckedId.has(page.id)) && !this.checked;
  }



  //***** Content Instractions
  uploadInstructions(): void {
    // Show the Content Instructions tab
    /* this.showContentInstructions = true;
    this.contentInstructionsTab.disable = false;
    
    // Navigate to the Content Instructions tab
    this.selectedIndex = 6; */
    this.showContentInstructions = true;
    this.tabs.forEach((item, index)=>{
      if(item.name == 'Content Instructions'){
        item.visible = true;
      }
    })
    this.tabs = this.tabs;
    this.cdRef.detectChanges();
    this.selectedIndex = 3;
  }
  // Format function for progress
  percentFormat = (percent: number): string => `${percent}%`;

  // File input element reference
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  // Method to handle file selection
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input || !input.files || input.files.length === 0) {
      return;
    }

    // Check max documents
    if (this.uploadedFiles.length >= this.maxDocuments) {
      console.warn(`Maximum number of documents (${this.maxDocuments}) reached.`);
      input.value = '';
      return;
    }

    const file = input.files[0];

    const allowedTypes = [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain'
    ];

    const allowedExtensions = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'txt'];
    const extension = file.name.split('.').pop()?.toLowerCase();

    if (
      (!file.type || !allowedTypes.includes(file.type)) &&
      (!extension || !allowedExtensions.includes(extension))
    ) {
      console.warn(`Invalid file type: ${file.name}`);
      input.value = '';
      return;
    }

    const newFile = {
      id: Date.now(),
      name: file.name,
      size: this.formatFileSize(file.size),
      progress: 0,
      documentType: '',
      documentDescription: '',
      uploading: true,
      file
    };

    this.uploadedFiles.push(newFile);
    this.simulateUploadProgress(newFile.id);

    this.tracking.trackEvent('action', `Selected document: ${newFile.name}`);

    // ✅ SAFE reset
    input.value = '';

    setTimeout(() => {
      const fileElements = document.querySelectorAll('.file-upload-card');
      fileElements[fileElements.length - 1]
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
  
  // Helper method to format file size
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // This method is now used for the "Add Document" button when files are already uploaded
  onAddDocument(): void {
    console.log('onAddDocument called');
    
    // Check if we're under the maximum document limit
    if (this.uploadedFiles.length >= this.maxDocuments) {
      console.warn(`Maximum number of documents (${this.maxDocuments}) reached.`);
      return;
    }
    
    // Try multiple ways to access the file input
    try {
      // First try using the ViewChild reference
      if (this.fileInput && this.fileInput.nativeElement) {
        console.log('Using ViewChild reference to click file input');
        this.fileInput.nativeElement.click();
        return;
      }
      
      // Try the global file input at the top level
      const globalFileInput = document.getElementById('global-document-file-input') as HTMLInputElement;
      if (globalFileInput) {
        console.log('Using global file input');
        globalFileInput.click();
        return;
      }
      
      // If ViewChild fails, try using getElementById
      const fileInputById = document.getElementById('document-file-input') as HTMLInputElement;
      if (fileInputById) {
        console.log('Using getElementById to click file input');
        fileInputById.click();
        return;
      }
      
      // If getElementById fails, try using querySelector
      const fileInputElement = document.querySelector('input[type="file"]') as HTMLInputElement;
      if (fileInputElement) {
        console.log('Using querySelector to click file input');
        fileInputElement.click();
        return;
      }
      
      // As a last resort, create a new file input dynamically and click it
      console.log('Creating dynamic file input as last resort');
      this.createFallbackFileInput();
      const newInput = document.getElementById('document-file-input') as HTMLInputElement;
      if (newInput) {
        newInput.click();
      } else {
        console.error('Failed to create and find dynamic file input');
      }
    } catch (err) {
      console.error('Error clicking file input:', err);
    }
  }

  // Helper method to simulate upload progress
  private simulateUploadProgress(fileId: number): void {
    // Find the file
    const file = this.uploadedFiles.find(f => f.id === fileId);
    if (!file) return;
    
    // Start at 0%
    file.progress = 0;
    
    // Simulate progress updates
    const interval = setInterval(() => {
      // Increment progress by a random amount between 5-15%
      const increment = Math.floor(Math.random() * 10) + 5;
      file.progress += increment;
      
      // Cap at 100%
      if (file.progress >= 100) {
        file.progress = 100;
        file.uploading = false;
        clearInterval(interval);
        
        // Set a default document type
        if (!file.documentType) {
          // Find a document type that matches the file name
          const matchingType = this.documentTypeOptions.find(option => 
            file.name.toLowerCase().includes(option.label.toLowerCase()));
          
          if (matchingType) {
            file.documentType = matchingType.value;
          } else {
            // Default to the first option
            file.documentType = this.documentTypeOptions[0].value;
          }
        }
        
        // Detect changes to update the UI
        this.cdRef.detectChanges();
      }
    }, 500); // Update every 500ms
  }

  removeUploadedFile(fileId: number): void {
    this.uploadedFiles = this.uploadedFiles.filter(file => file.id !== fileId);
    this.tracking.trackEvent('action', `Removed uploaded file with ID: ${fileId}`);    
  }

  onDocumentTypeChange(fileId: number, documentType: string): void {
    const file = this.uploadedFiles.find(f => f.id === fileId);
    if (file) {
      file.documentType = documentType;
      this.tracking.trackEvent('action', `Set document type to ${documentType} for file ${file.name}`);
    }
  }
  // Create a fallback file input if the ViewChild reference isn't working
  private createFallbackFileInput(): void {
    const existingInput = document.getElementById('document-file-input') as HTMLInputElement;
    if (!existingInput) {
      console.log('Creating fallback file input element');
      const input = document.createElement('input');
      input.type = 'file';
      input.id = 'document-file-input';
      input.accept = '.doc,.docx,.pdf,.txt';
      input.style.display = 'none';
      input.addEventListener('change', (event) => this.onFileSelected(event));
      document.body.appendChild(input);
    }
  }
  proceedFromUploadInstructions(): void {
    if (this.uploadedFiles.length == 0) {
      this.onNext();
      return;
    }
    this.isUploadAnalyzing = true;   
    this.UploadInstructionsDocs();
  }
  
  UploadInstructionsDocs() {
    let request = new UploadInstDocsRequest();
    //request.campaignId = this.campaignId;
    //request.profileId = this.profileId;
    request.files = this.uploadedFiles; // Extract the actual File objects
    this.campaignService.uploadInstructionDocuments(request).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response.success) {
          // Simulate analysis for 3 seconds

          this.documentDetails = response.documentDetailsResult;
          this.isUploadAnalyzing = false;
          this.selectedIndex = 4;
          this.cdRef.detectChanges();
          console.log('Instruction Document uploaded successfully:', response);
        }
      },
      error: (err) => {
        console.error('Instruction Document upload failed:', err);
        this.isUploadAnalyzing = false;
      },
      complete: () => {
        console.log('Instruction Document upload completed');
        this.isUploadAnalyzing = false;
      },
    });
  }


  ngAfterViewInit(): void {
    // Check if fileInput is properly initialized
    setTimeout(() => {
      if (!this.fileInput) {
        console.warn('fileInput reference not available after view init');
        // Create a fallback file input if the ViewChild reference isn't available
        this.createFallbackFileInput();
      } else {
        console.log('fileInput reference successfully initialized');
      }
    }, 0);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  manageTemplates(){
    const route = this.router.createUrlTree(['/settings']);
    const url = this.router.serializeUrl(route) + "/content-templates"; 
    window.open(url, '_blank');
  }

  isButtonDisabled(): boolean {
    // Get all selected pages
    const selectedTemplates = this.pageData.filter(x => this.setOfCheckedId.has(x.id));

    // Rule 1: No page selected → disable button
    if (selectedTemplates.length === 0) {
      return true;
    }

    // Rule 2: If any selected page has empty keywords or template → disable button
    const hasInvalid = selectedTemplates.some(
      p => !p.keywords || p.keywords.length === 0 || !p.template || p.template.trim() === '' || p.template == "00000000-0000-0000-0000-000000000000" ||
      !this.templates.find(s=>s.id == p.template)
    );

    if (hasInvalid) {
      return true;
    }

    // Otherwise enable button
    return false;
  }

  /* Brand Modal */
  createNewBrand() {
    if (this.newBrandName && this.newBrandName.trim() !== '') {
      // Check if brand already exists to prevent duplicates
      const brandExists = this.brandSelection.some(brand => 
        brand.value.toLowerCase() === this.newBrandName.toLowerCase().trim()
      );

      if (brandExists) {
        this.errorMessage = 'Brand name already exists';
        this.notification.template(this.ErrorAlertTemplate, { 
          mwcDuration: 3000, 
          mwcStyle: { padding: '16px' }, 
          mwcPlacement: 'top', 
          mwcClass: 'error-notification-content' 
        });
        return;
      }

      // Create new brand object and add to array
      const newBrand = {
        label: this.newBrandName.trim(),
        value: this.newBrandName.trim()
      };
      
      this.brandSelection.push(newBrand);
      
      // Set the newly created brand as selected
      this.brandSelectedValue = newBrand.value;
      
      // Close modal and reset input
      this.isAddBrandModalVisible = false;
      this.newBrandName = '';
      
      // Show success notification
      this.notification.snackbarSuccess('Brand added successfully');
      
      // Ensure UI is updated
      this.cdRef.detectChanges();
    }
  }
  openBrandVoiceModal() { 
    this.isAddBrandModalVisible = true;
  }
  cancelAddBrand() {
    this.isAddBrandModalVisible = false;
  }

  deletePage(page: any) {
    this.editingPagenId = page.id;
    this.pages = this.pages.filter((p: any) => p.id !== page.id);
  }

  renamePage(data: any) {
    this.editingPagenId = data.id;
    this.originalPageName = data.title?.trim() || '';
  }
  cancelEditing() {
    const page = this.pages.find(c => c._id === this.pages);
    if (page) {
      page.title = this.originalPageName;
    }
    this.editingPagenId = null;
  }
  savePageName(data: any) {
    const trimmedName = data.title?.trim();
    this.editingPagenId = null;
  }
  // Section management methods
  addNewSection() {
    this.isAddingNewSection = true;
    this.newSection = {
      id:  this.pageData.length + 1,
      title: '',
      url: '',
      keywords: [],
      template: '',
      disabled: false
    };
  }

  cancelAddSection() {
    this.isAddingNewSection = false;
    this.newSection = {
      id: '',
      sectionTitle: '',
      wordCount: 0,
      contentPrompt: ''
    };
  }


  //
  saveNewSection(){
    if (this.newSection.title.trim() !== '' && this.newSection.template && this.newSection.keywords.length >= 0) {
      const newSection = {
        id: this.pageData.length + 1,
        title: this.newSection.title,
        url: '',
        keywords: this.newSection.keywords,
        template: this.newSection.template,
        disabled: false
      };
      this.setOfCheckedId.add(newSection.id);
      this.pageData.push(newSection);
      this.isAddingNewSection = false;
      this.newSection = {
        id: '',
        sectionTitle: '',
        wordCount: 0,
        contentPrompt: ''
      };
    }
  }
  // Method to handle adding a new keyword to a page
  addNewKeywordToPage(pageIndex: number): void {
    this.activePageIndex = pageIndex;
    // Initialize selected keywords with the ones already on the page
    this.selectedKeywords = [...this.newSection.keywords];
    this.openNewInputTag();
  }
    // Method to add selected keywords to the page and close dropdown
  confirmNewKeywordSelection(): void {
    this.newSection.keywords = [...this.selectedKeywords]
    
    // Close dropdown using DOM API
    this.closeDropdown();
    this.selectedKeywords = [];
    this.activePageIndex = null;
  }
  addNewTag(){
    const trimmedTag = this.newTagText.trim();
    if (!trimmedTag) {
      this.showTagInput = false;
      return;
    }
    
    // Check for duplicates in listOfOption
    const isDuplicate = this.listOfOption.some(
      option => option.label.toLowerCase() === trimmedTag.toLowerCase()
    );
    
    if (isDuplicate) {
      this.isDuplicateKeyword = true;
      return;
    }
    
    // Add the new tag to listOfOption
    this.listOfOption = [...this.listOfOption, { label: trimmedTag, value: trimmedTag }];
    // Also add to allKeywords to keep them in sync
    if (!this.allKeywords.includes(trimmedTag)) {
      this.allKeywords = [...this.allKeywords, trimmedTag];
    }
    
    this.newTagText = '';
    this.isDuplicateKeyword = false;
    this.showTagInput = false;
  }
  
  onNewTagInput(): void {
    const trimmedTag = this.newTagText.trim();
    if (!trimmedTag) {
      this.isDuplicateKeyword = false;
      return;
    }
    
    // Check for duplicates in listOfOption
    this.isDuplicateKeyword = this.listOfOption.some(
      option => option.label.toLowerCase() === trimmedTag.toLowerCase()
    );
  }
  
  openNewInputTag(){
    this.newTagText = '';
    this.isDuplicateKeyword = false;
    this.showTagInput = true;
  }
}
